import company from './company'

import order from './order'

import partner from './partner'

import trip from './trip'

import dashboard from './dashboard'

export default [

  ...company,

  ...partner,
  ...order,

  ...trip,

  ...dashboard

] as {
  [key: string]: any
}[]
